// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2025-10-12 22:58:48 +0200 (Sun, 12 Oct 2025) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: o.powroznik $
// Revision    : $Rev: 157129 $
// Purpose     : some examples and some whiteboard space for /test/whiteboard
// =============================================================================
// ---Third-party imports
import clsx from 'clsx'
import React, {useState, useEffect, useMemo} from 'react'

// ---Local imports
import S from './index.scss'

// ---Exports
export {TextTicker} from './textTicker'
export {TextTickerSelection} from './textTickerPicker'
export {AudioTicker, AudioWaves} from './audioticker'
export {Showcase} from './showcase'
export {SlideIndicator} from './slideIndicator'
export {AiPrompt, AiImage} from './ai'
export {PageViewer} from './pageViewer'
export {Modal} from './modal'
export {MediaPlayer} from './mediaplayer'

export const GhostText = ({className, fontSize = '1rem', lines = 8, style}) => {
  let lineStyles = useMemo(() => {
    return Array.from({length: lines}).map(() => ({
      width: `${Math.floor(Math.random() * 51) + 50}%`,
      height: fontSize,
    }))
  }, [lines, fontSize])

  return (
    <div style={style} className={clsx(className, S.placeholder)}>
      {lineStyles.map((style, i) => (
        <div key={i} className={S.line} style={style} />
      ))}
    </div>
  )
}

export const GhostImage = ({width = '160px', height = '320px', style}) => {
  return (
    <div
      className={clsx(S.placeholder, S.image)}
      style={{width: width, height: height, ...style}}
    ></div>
  )
}
